import React, { useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { Ruler, PlusCircle, Pencil, Trash2 } from 'lucide-react';

function Madhesite() {
  const [emri, setEmri] = useState('');
  const [editId, setEditId] = useState(null);

  const { data: madhesiteData, execute: refetchMadhesite } = useApi(
    () => apiService.get('/madhesite'),
    [],
    { immediate: true, showNotifications: false }
  );

  const madhesite = Array.isArray(madhesiteData) ? madhesiteData : (madhesiteData?.data || []);

  const { mutate: saveMadhesi, loading: saving } = useMutation(
    async (emri) => {
      if (editId) {
        return await apiService.put(`/madhesite/${editId}`, { emri });
      } else {
        return await apiService.post('/madhesite', { emri });
      }
    },
    {
      successMessage: editId ? 'Madhësia u përditësua me sukses!' : 'Madhësia u shtua me sukses!',
      onSuccess: () => {
        setEmri('');
        setEditId(null);
        refetchMadhesite();
      }
    }
  );

  const { mutate: deleteMadhesi } = useMutation(
    async (id) => {
      return await apiService.delete(`/madhesite/${id}`);
    },
    {
      successMessage: 'Madhësia u fshi me sukses!',
      onSuccess: () => {
        refetchMadhesite();
      }
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    saveMadhesi(emri);
  };

  const handleEdit = (m) => {
    setEditId(m.id);
    setEmri(m.emri);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('A dëshironi të fshini këtë madhësi?')) return;
    deleteMadhesi(id);
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <Ruler size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Madhësitë e Produkteve
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 mb-8 flex gap-4">
        <input
          type="text"
          value={emri}
          onChange={(e) => setEmri(e.target.value)}
          placeholder="Shkruaj madhësinë (p.sh. S, M, L)"
          className="input-premium flex-1"
          required
        />
        <button
          type="submit"
          disabled={saving}
          className="btn-primary flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <PlusCircle size={18} />
          {saving ? 'Po ruhet...' : (editId ? 'Përditëso' : 'Shto')}
        </button>
      </form>

      <div className="card-premium overflow-hidden">
        <table className="table-premium">
          <thead>
            <tr>
              <th>#</th>
              <th>Madhësia</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {madhesite.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Nuk ka madhësi të regjistruar
                </td>
              </tr>
            ) : (
              madhesite.map((m, i) => (
                <tr key={m.id}>
                  <td>{i + 1}</td>
                  <td className="font-medium">{m.emri}</td>
                  <td className="space-x-2">
                    <button onClick={() => handleEdit(m)} className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 inline-flex items-center gap-1 transition-colors">
                      <Pencil size={16} /> Edito
                    </button>
                    <button onClick={() => handleDelete(m.id)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 inline-flex items-center gap-1 transition-colors">
                      <Trash2 size={16} /> Fshi
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Madhesite;
